export default {
  Common: {
    Title: "Danh sách đợt thu tiền",
    Placeholder: "Nhập tên đợt thu tiền",
  },
  List: {
    Column: {
      Period: "Đợt thu tiền",
      Count: "Số lượng yêu cầu thanh toán",
      TotalAmount: "Tổng tiền",
      AmountPaid: "Đã thu",
      AmountRemain: "Còn lại",
    },
  },
  CreatePopup: {
    Title: "Thêm đợt thu tiền",
    PeriodName: "Tên đợt thu tiền",
    PaymentTerm: "Hạn thanh toán",
    ErrorExist: "Tên đợt thu đã tồn tại trong hệ thống!",
    ErrorDueDate: "Hạn thanh toán phải lớn hơn ngày hiện tại",
  },
  DuplicatePopup: {
    Title: "Nhân bản đợt thu tiền",
    PeriodName: "Tên đợt thu tiền",
    PaymentTerm: "Hạn thanh toán",
  },
  Tooltip: {
    Name: "Đợt thu tiền",
    Count: "Số lượng yêu cầu thanh toán",
    TotalAmount: "Tổng tiền",
    AmountPaid: "Đã thu",
    AmountRemain: "Còn lại",
    Status: "Trạng thái",
    CreatedDate: "Ngày tạo",
    DueDate: "Hạn thanh toán",
  },
};
